import { render, staticRenderFns } from "./PromptLeave.vue?vue&type=template&id=04a8c01a&"
import script from "./PromptLeave.vue?vue&type=script&lang=js&"
export * from "./PromptLeave.vue?vue&type=script&lang=js&"
import style0 from "./PromptLeave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PromptLeave.vue"
export default component.exports